/**
 * <s-login-popup data-delay>: opens its sign-in dialog once per browser after
 * the delay (seconds). Any [data-login-dismiss] click or closing the dialog
 * remembers the choice in localStorage ("th-login-seen") so it never nags.
 * Never opens inside the theme editor preview.
 */
const SEEN = 'th-login-seen';

class LoginPopup extends HTMLElement {
  #abort = null;
  #timer = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    this.dialog = this.querySelector('dialog');
    let seen = false;
    try {
      seen = localStorage.getItem(SEEN) === '1';
    } catch {
      seen = true;
    }
    if (!this.dialog || seen || window.Shopify?.designMode) return;
    const remember = () => {
      try {
        localStorage.setItem(SEEN, '1');
      } catch {
        /* storage unavailable */
      }
    };
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-login-dismiss]')) remember();
      if (event.target === this.dialog) this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('close', remember, { signal });
    const mobile = this.querySelector('[data-mobile-form]');
    mobile?.addEventListener('submit', (event) => {
      event.preventDefault();
      const phone = mobile.elements.phone.value.trim();
      const digits = phone.replace(/\D/g, '');
      const error = mobile.querySelector('[data-mobile-error]');
      if (digits.length < 10 || digits.length > 13) {
        error.hidden = false;
        mobile.elements.phone.focus();
        return;
      }
      error.hidden = true;
      const consent = mobile.elements.wa_updates.checked;
      try {
        localStorage.setItem('th-login-phone', phone);
        localStorage.setItem('th-login-wa', consent ? '1' : '0');
      } catch {
        /* storage unavailable */
      }
      const d = mobile.dataset;
      const text = (d.message || '').replace('__PHONE__', phone).replace('__CONSENT__', consent ? d.yes : d.no);
      window.open(`https://wa.me/${d.wa}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
      remember();
      this.dialog.close();
    }, { signal });
    const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
    this.#timer = setTimeout(() => {
      if (!this.dialog.open && !document.querySelector('dialog[open]')) this.dialog.showModal();
    }, delay);
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
    this.#abort?.abort();
  }
}

if (!customElements.get('s-login-popup')) customElements.define('s-login-popup', LoginPopup);
